// DanceFlooringInc — base theme JS.
// Loaded with `defer` so it runs after the DOM parses.

(function () {
  'use strict';

  // Mark JS-on so CSS can hide non-JS fallbacks.
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  // ---------- Lightweight event bus ----------
  window.DFI = window.DFI || {};
  window.DFI.bus = (function () {
    const listeners = {};
    return {
      on(name, fn) { (listeners[name] = listeners[name] || []).push(fn); },
      emit(name, payload) { (listeners[name] || []).forEach(fn => fn(payload)); }
    };
  })();

  // ---------- Mobile nav toggle ----------
  function initNavToggle() {
    const toggle = document.querySelector('[data-nav-toggle]');
    const nav = document.querySelector('[data-nav]');
    if (!toggle || !nav) return;
    // Below 900px the same <nav> is an overlay drawer; at/above it is the
    // always-visible desktop menu. We must ONLY make the closed drawer inert /
    // lock body scroll in the mobile breakpoint — never disable the desktop nav.
    const mq = window.matchMedia('(max-width: 900px)');

    function setOpen(open) {
      const drawer = mq.matches;
      toggle.setAttribute('aria-expanded', String(open));
      nav.setAttribute('data-open', String(open));
      // inert removes the closed drawer AND all descendants (incl. the mega panel)
      // from hit-testing + the tab/AT tree, regardless of any inner pointer-events.
      nav.inert = drawer && !open;
      if (drawer && !open) nav.setAttribute('aria-hidden', 'true');
      else nav.removeAttribute('aria-hidden');
      // lock the page behind the open drawer so it can't scroll underneath.
      document.body.classList.toggle('nav-open', drawer && open);
    }

    toggle.addEventListener('click', () => {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') setOpen(false);
    });

    // Re-sync on viewport change (rotate / resize across the breakpoint) so the
    // desktop nav is never left inert and the scroll-lock is dropped on the way up.
    mq.addEventListener('change', () => {
      setOpen(toggle.getAttribute('aria-expanded') === 'true' && mq.matches);
    });

    setOpen(false); // start closed (and, on mobile, inert)
  }

  // ---------- Cart count refresh ----------
  // Listens for `cart:updated` events from product/cart pages and refreshes
  // the bag count in the header without a full reload.
  function initCartCount() {
    window.DFI.bus.on('cart:updated', (cart) => {
      if (!cart) return;
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = ' · ' + (cart.item_count || 0);
      });
    });
  }

  // ---------- Product-page "add a free sample" ----------
  // Wires the buybox's "Order a free sample" link to add the $0 Free Sample
  // product for THIS floor, recording the floor name as a line-item property.
  // Respects the 3-free-samples cap shared with the samples picker page.
  function initPdpSample() {
    const link = document.querySelector('.pbuy__sample-link');
    if (!link) return;
    const MAX = 3;
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const titleEl = document.querySelector('.pbuy__title');
    const floor = (ogTitle && ogTitle.content)
      ? ogTitle.content
      : (titleEl ? titleEl.textContent.trim() : 'Selected floor');
    let sampleVid = null;

    function feedback(msg) {
      let el = link.parentNode.querySelector('[data-pdp-sample-msg]');
      if (!el) {
        el = document.createElement('span');
        el.setAttribute('data-pdp-sample-msg', '');
        el.style.cssText = 'display:block;margin-top:0.45rem;font-size:0.85rem;opacity:0.9;';
        link.parentNode.insertBefore(el, link.nextSibling);
      }
      el.textContent = msg;
    }

    function getVid() {
      if (sampleVid) return Promise.resolve(sampleVid);
      return fetch('/products/free-sample.js')
        .then(r => r.json())
        .then(p => { sampleVid = p.variants[0].id; return sampleVid; });
    }

    link.addEventListener('click', (e) => {
      e.preventDefault();
      fetch('/cart.js').then(r => r.json()).then(cart => {
        const n = (cart.items || [])
          .filter(i => i.handle === 'free-sample')
          .reduce((a, i) => a + i.quantity, 0);
        if (n >= MAX) {
          feedback('You have reached ' + MAX + ' free samples. View your bag to check out or swap one out.');
          return;
        }
        return getVid().then(vid =>
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: { Finish: floor } }] })
          })
        ).then(r => { if (r && !r.ok) throw new Error('add failed'); return r && r.json(); })
         .then(() => {
           feedback('Added a free sample of this floor (' + (n + 1) + ' of ' + MAX + '). View your bag to check out.');
           window.DFI.bus.emit('cart:updated', { item_count: (cart.item_count || 0) + 1 });
         });
      }).catch(() => feedback('Sorry — could not add the sample just now. Please try again.'));
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initNavToggle();
    initCartCount();
    initPdpSample();
  });
})();
